module.exports = __webpack_public_path__ + "media/logos/garmin-5db081ad.svg";